import React from 'react';
import { Helmet } from '@okapi/helmet-react';

export const MetaHTML = () => (
	<Helmet>
		<html lang="ru" />
		<link
			rel="preload"
			href="https://static.lemanapro.ru/fronton/lm-main/demi-bold.woff2"
			as="font"
			crossOrigin="anonymous"
		/>
		<link
			rel="preload"
			href="https://static.lemanapro.ru/fronton/lm-main/regular.woff2"
			as="font"
			crossOrigin="anonymous"
		/>
		<link
			href="https://static.lemanapro.ru/fronton/lm-fonts.css"
			rel="preload"
			as="style"
			crossOrigin="anonymous"
			onLoad={"this.rel = 'stylesheet'" as never}
		/>
	</Helmet>
);
